<template>
  <div class="my-coupon" v-show="unCouponData && unCouponData.length > 0">
    <!-- 不可用券 -->
    <div class="coupon-unavailable">
      <List
        v-if="unCouponData && unCouponData.length"
        :disabled="disabled"
        :auto-load="autoLoad"
        :distance="distance"
        :load-more-status="unLoadMoreStatus"
        @more="unGetCouponList"
      >
        <el-row :gutter="10" class="shop-list-wrapper">
          <el-col
            :xs="24"
            :sm="8"
            v-for="(coupon, index) in unCouponData"
            :key="'shop' + index"
            class="coupon-col"
          >
            <div class="grey">
              <!-- 可用优惠券 -->
              <soda-coupon-cell
                class="coupon-content"
                :key="index"
                :index="index"
                :couponSrc="coupon"
                :selectable="false"
                :isUseLink="true"
                :country="country"
                :isMoreTip="!isH5"
                :openedCityList="openedCityList"
                backgroundColor="#F5F5F7"
                theme="useCell"
                :from="2"
                @handleUse="handleUse(coupon, index)"
              ></soda-coupon-cell>
            </div>
          </el-col>
        </el-row>
      </List>
    </div>
  </div>
</template>

<script>
import List from '@/components/List';
import { mapState, mapActions } from 'vuex';
import { getLanguageLong } from '@didi/gettext';
export default {
  name: 'MyCouponUnavailable',
  components: {
    List,
  },
  data() {
    return {
      disabled: false,
      distance: 30,
      autoLoad: false,

      unLoadMoreStatus: 'suc', // 加载状态 suc fail nomore loading
      unLoadMoreStatusRem: 'suc',
      unCouponData: [],
      unCurrentPage: 1, // 标识当前展示券列表的第几页

      size: 6,
      isInit: false,
      isLastPage: false, // 标识是否已翻到最后一页
    };
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
      openedCityList: ({ common }) => common.openedCityList,
      country: ({ common }) => common.country,
    }),
  },
  async mounted() {
    this.unCouponData = [];
    this.unCurrentPage = 1;
    await this.unGetCouponList();
    this.$emit('update', this.unCouponData?.length);
  },
  methods: {
    ...mapActions('coupon', ['getWalletCoupons']),

    /** @desc 不可用券 **/
    async unGetCouponList() {
      this.unLoadMoreStatus = 'loading';
      this.unLoadMoreStatusRem = 'loading';

      const res = await this.getWalletCoupons({
        utc_offset: 0 - new Date()?.getTimezoneOffset(),
        expire_flag: 2,
        page: this.unCurrentPage,
        lang: getLanguageLong(),
        size: this.size,
      });
      this.unCouponData = this.unCouponData.concat(res?.couponList);
      this.unCurrentPage++;
      this.unLoadMoreStatus = res?.next ? 'suc' : 'nomore';
      this.unLoadMoreStatusRem = res?.next ? 'suc' : 'nomore';
    },
  },
};
</script>

<style lang="scss" scoped>
.my-coupon {
  width: 1156px;
  margin: 0 auto;
  .coupon-line {
    width: 300px;
    margin: 18px auto;
  }
  .my-back {
    font-family: 'Aspira Medium';
    font-size: 20px;
    line-height: 56px;
  }
  .coupon-content {
    width: 372px;
    margin-bottom: 20px;
  }
  .coupon-card {
    width: 372px;
    height: 135px;
    box-sizing: border-box;
    padding: 36px 0;
    background: #ffffff;
    border-radius: 8px;
  }
  .grey {
    filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
  }
  .grey:hover {
    z-index: 99;
    position: relative;
  }
}
@media screen and (max-width: 768px) {
  .my-coupon {
    width: 100%;
    .coupon-card {
      width: rem(702);
      max-width: 390px;
      height: unset;
      box-sizing: border-box;
      padding: 0;
      background: unset;
      border-radius: 8px;
      margin-bottom: 20px;
    }
    .coupon-content {
      width: rem(702);
      margin-bottom: 20px;
    }
  }
}
</style>